import React, { useRef, useLayoutEffect, useEffect, useState } from 'react';

import { ADAWidgitRoles } from '../../../../models/ADA';

import './InfoTooltip.scss';
import icon from './info-tooltip-icon.png';

const InfoTooltip = ({ text, parentRef }) => {
  const content = useRef(null);
  const [popupActive, setPopupActive] = useState(false);
  const refPopupActive = useRef(popupActive);
  const [popupDimensions, setPopupDimensions] = useState({
    left: 0,
    width: 0,
  });
  const [arrowLeft, setArrowLeft] = useState(0);

  const handleResize = () => {
    setPopupActive(false);
    refPopupActive.current = false;
  };

  const handleDocumentClick = (ev) => {
    if (refPopupActive.current) {
      let clickedOnPopup = false;
      let el = ev.target;
      while (el) {
        if (el === content.current) {
          clickedOnPopup = true;
          break;
        }
        el = el.parentNode;
      }
      if (!clickedOnPopup) {
        setPopupActive(false);
      }
    }
  };

  const handleKeyDown = (e) => {
    if(e.key === 'Escape' || e.key === 'Tab'){
      setPopupActive(false);
    }
  }

  const activatePopup = () => {
    if (popupActive) {
      setPopupActive(false);
      return;
    }

    const parentRect = parentRef.current.getBoundingClientRect();
    const rect = content.current.getBoundingClientRect();
    const popupLeft = rect.x - parentRect.x - 20;
    setPopupDimensions({
      left: `-${popupLeft}px`,
      width: `${parentRect.width - 2 * 20}px`
    });
    setArrowLeft(`${popupLeft + rect.width / 2}px`);
    setPopupActive(true);
    refPopupActive.current = true;
  };

  useLayoutEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleKeyDown);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('click', handleDocumentClick);
    document.removeEventListener('keydown', handleKeyDown);

    };
  }, []);

  // useEffect(() => {
  //   if (animatedPart) {
  //     if (text.indexOf(animatedPart) < 0) {
  //       throw new Error('The text does not contain the provided animated part');
  //     }
  //     setInitialText(text.replace(animatedPart, 0));
  //     animationDone.current = false;
  //   } else {
  //     setInitialText(text);
  //     animationDone.current = true;
  //   }
  //   refText.current = text;
  //   refAnimatedPart.current = animatedPart;
  // }, [text, animatedPart]);

  return (
    <div
      className="vbn-info-tooltip"
      ref={content}
      role={ADAWidgitRoles.Button}
      aria-expanded={popupActive}
      aria-label={!popupActive ? "Show info tooltip" : `Showing info tooltip. ${text}`}
      aria-live={true}
      tabIndex="0"
      onClick={() => activatePopup()}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.keyCode === 32) && e.target === document.activeElement) {
          
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      onKeyUp={(e) => {
        if ((e.key === 'Enter' || e.keyCode === 32) && e.target === document.activeElement) {
          
          activatePopup();
        }
      }}
    >
      <div className="vbn-it-placeholder"><img src={icon} aria-hidden={true}/></div>
      <div className={`vbn-it-popup-holder ${ popupActive ? 'active' : '' }`}>
        <div className="vbn-it-popup-wrapper" style={popupDimensions}>
          <div className="vbn-it-popup--black-rect"></div>
          <div className="vbn-it-popup--arrow" style={{ left: arrowLeft }}></div>
          <div className="vbn-it-popup--white-rect"></div>
          <div className="vbn-it-popup--text" aria-hidden="true">{text}</div>
        </div>
      </div>
    </div>
  );
};

export default InfoTooltip;
